import { Dispatch } from "react";
import { CleanImageType, CleaningDateList, CleaningDetailImageList, CleaningDetailRouteList, CleaningRouteList } from "./state";
import { ChangeAttendaceDateTimeAction, ChangeCleaningDateTimeAction, ChangeClickCleaningDateFolderAction, CleaningAction, changeCleaningBinInfoAction, changePeopleCounterNumberAction, initCleaningDateListAction, initCleaningDetailPhotoAction, initCleaningDetailRouteListAction, initCleaningImageTypeListAction, initCleaningRouteListAction, selectedCleaningDetailRouteAction } from "./action";
import { SingleValue } from "react-select";
import { BinInfo } from "../staticInfo/state";

export function initCleaningDateThunk(cleaningDateList:CleaningDateList[]){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningDateListAction(cleaningDateList));
    };
}

export function initCleaningRouteThunk(cleaningRouteList:CleaningRouteList[]){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningRouteListAction(cleaningRouteList));
    };
}


export function initCleaningDetailRouteThunk(cleaningDetailRouteList:CleaningDetailRouteList[]){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningDetailRouteListAction(cleaningDetailRouteList));
    };
}

export function initCleaningDetailRoutePhotoThunk( cleaningDetailImageList:CleaningDetailImageList[]){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningDetailPhotoAction(cleaningDetailImageList));
    };
}


export function selectedCleaningDetailRouteThunk( selectedCleaningDetail:CleaningDetailRouteList){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(selectedCleaningDetailRouteAction(selectedCleaningDetail));
    };
}

export function changeCleaningBinInfoThunk(binInfo:SingleValue<BinInfo>){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(changeCleaningBinInfoAction(binInfo));
    };
}

export function updateCleaningDetailThunk(cleaningDetailRouteList: CleaningDetailRouteList[],data:CleaningDetailRouteList){
    const newCleaningDetailRouteList =  cleaningDetailRouteList.map((route)=>{
        if (route.cleaning_detail_route_id===data.cleaning_detail_route_id){
            return data
        }else{
            return route
        }
    })
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningDetailRouteListAction(newCleaningDetailRouteList));
    };
}

export function ChangeCleaningAttendaceDateTimeThunk(date:string ) {
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(ChangeAttendaceDateTimeAction(date));
    };
}

export function ChangeCleaningDateTimeThunk(date: Date | moment.Moment ) {
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(ChangeCleaningDateTimeAction(date));
    };
}

export function ChangeClickCleaningDateFolderThunk(clickDate: string ) {
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(ChangeClickCleaningDateFolderAction(clickDate));
    };
}

export function initCleaningImageTypeListThunk(imagetypeList:CleanImageType[]){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(initCleaningImageTypeListAction(imagetypeList));
    };
}


export function changePeopleCounterNumberThunk(people_counter_number:string){
    return (dispatch: Dispatch<CleaningAction>) => {
        dispatch(changePeopleCounterNumberAction(people_counter_number));
    };
}